document.addEventListener('click', (event) => {
  const menu = document.querySelector('.mobile-nav');
  if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.mobile-nav[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});
